export default "__VITE_ASSET__ChexBPp0__"